var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FastSimonReporting as FastSimonReportingModule } from "../components/FastSimonReporting";
import promisify from "./promisify";
export function getFastSimonReporting(props) {
    if (typeof FastSimonReporting !== "undefined") {
        return promisify(FastSimonReporting);
    }
    return newReporter(props);
}
function newReporter(props) {
    return __awaiter(this, void 0, void 0, function* () {
        const reporter = new FastSimonReportingModule(props).initialize();
        window.FastSimonReporting = reporter;
        return new Promise((resolve) => resolve(reporter));
    });
}
//# sourceMappingURL=getFastSimonReporting.js.map